export const planetChartData = {
  type: 'bar',
  data: {
    labels: ["FLEX", "CONVENCIONAL"],
    datasets: [
      { // one line graph
        label: 'TIEMPO PROMEDIO DE RESPUESTAS A REPLICAS',
        data: [5, 10],
        backgroundColor: [
          'rgba(54,73,93,.5)', // Blue
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)'
        ],
        borderColor: [
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
        ],
        borderWidth: 3
      },
    ]
  },
  options: {
    responsive: true,
    // maintainAspectRatio: false,
    lineTension: 1,
    scales: {
      yAxes: [{
        ticks: {
          // callback: function (value) {
          //   return value + " %";
          // },

          min: 0,          
          beginAtZero: true
        },
        scaleLabel: {
          display: true,
          fontSize: 12,

        }
      }]
    }
  }
}

export default planetChartData;